import { z } from "zod";
import {
  KycSchema,
  PreReviewDocumentSchema,
  RelationshipSchema,
  UserSchema,
} from "../treezor/index.js";
import getTreezorAccountCreatorKycLiveness from "./getTreezorAccountCreatorKycLiveness.js";

export default {
  params: z.object({
    accountId: z.string(),
  }),
  response: getTreezorAccountCreatorKycLiveness.response.extend({
    user: UserSchema.extend({ kyc: KycSchema.optional() }),
    documents: z.array(PreReviewDocumentSchema),
    relationship: RelationshipSchema.nullable(),
    isLegalRepresentative: z.boolean(),
    isEffectiveBeneficiary: z.boolean(),
  }),
};
